import { addIsi, editIsi, uploadFile } from "./actions.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import attachables from "./attachables.js";

export default [{
    "path": "/SafetyManagement/InformationSecurityRisks",
    "component": { ...ItemListView },
    "name": "Information Security Risks",
    "meta": {
        "app": "SafetyManagement",
        "sideNav": true,
        "appSwitcher": false,
        "sideNavSection": "Information Security Management",
        "name": "Information Security Risks",
        "tableSettings": "InformationSecurityRisks",
        "dataPath": "SafetyManagement/InformationSecurityRisks",
        "selectionRoute": "SafetyManagement/InformationSecurityRisks/{ID}",
        "menuActions": [{
            "label": "Add Information Security Risk",
            "action": addIsi
        }]
    }
}, {
    "path": "/SafetyManagement/InformationSecurityRisks/:id",
    "component": ItemView,
    "name": "Information Security Risk",
    "meta": {
        "app": "SafetyManagement",
        "name": "Information Security Risk",
        "dataPath": "SafetyManagement/InformationSecurityRisks",
        "title": (item) => `Information Security Risk: ${item.Number}`,
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "md:col-span-2"
        }, {
            "label": "Latest Revision",
            "key": "Revision",
            "type": "text",
            "actionButton": true,
            "actionText": "Download",
            async action({ pageItem, db }) {
                let url = await db.download(`Database/InformationSecurityRisks/${pageItem.ID}/Revisions/${pageItem.RevisionID}/${pageItem.Revisions[pageItem.RevisionID].File}`);
                window.open(url, "fileView", "popup");
            }
        }],
        "menuActions": [{
            "label": "Edit",
            "action": editIsi
        }, {
            "label": "Upload File",
            "action": uploadFile
        }],
        "attachedItems": {
            "Details": {
                "attachables": attachables
            }
        }
    }
}];
